// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Z-o9","buttons":"SendReceipts_buttons__2ThFP","email":"SendReceipts_email__WlOod","bookApptTitle":"SendReceipts_bookApptTitle__1-g--"};